import { CLICK_PORTAL_SEARCH_FILTERS, QUERY_PARAMS } from 'consts';
import { SchoolFilters } from 'types';

const {
  FILTER_KEY_PARAM,
  DEGREE_GUID_PARAM,
  PARENT_CAT_GUID_PARAM,
  CATEGORY_GUID_PARAM,
} = QUERY_PARAMS;

function readQueryValue(
  query: Record<string, unknown> | URLSearchParams,
  key: string
): string {
  if (typeof (query as URLSearchParams).get === 'function') {
    return (query as URLSearchParams).get(key) || '';
  }

  const value = (query as Record<string, unknown>)[key];
  if (Array.isArray(value)) {
    return value[0] == null ? '' : String(value[0]);
  }

  if (value == null) {
    return '';
  }
  return String(value);
}

function toSchoolFilters(
  filterKey: string,
  degree: string,
  subject: string,
  category: string
): SchoolFilters {
  return {
    [CLICK_PORTAL_SEARCH_FILTERS.FILTER_KEY]: filterKey,
    [CLICK_PORTAL_SEARCH_FILTERS.DEGREES]: { value: degree },
    [CLICK_PORTAL_SEARCH_FILTERS.SUBJECTS]: { value: subject },
    [CLICK_PORTAL_SEARCH_FILTERS.CONCENTRATIONS]: { value: category },
  };
}

/**
 * A filter key, or all three guid params, replaces the section's curated row.
 * Any other query string leaves the WordPress row in charge.
 */
export default function listingFiltersFromQuery(
  query: Record<string, unknown> | URLSearchParams
): SchoolFilters | null {
  const filterKey = readQueryValue(query, FILTER_KEY_PARAM);
  if (filterKey) {
    return toSchoolFilters(filterKey, '', '', '');
  }

  const degree = readQueryValue(query, DEGREE_GUID_PARAM);
  const subject = readQueryValue(query, PARENT_CAT_GUID_PARAM);
  const category = readQueryValue(query, CATEGORY_GUID_PARAM);
  if (degree && subject && category) {
    return toSchoolFilters('', degree, subject, category);
  }

  return null;
}
